export default __webpack_public_path__ + "static/media/EG_Zoom-1.c5f3ac68.wav";